class WaterCalculator {
  constructor() {
  
    this.resultsContainer = document.querySelector('.storage-recommendations');
    this.config = {
      survivalTypes: {
        basic: [1, 0.5, 1, 1, 2.5, 0.5, 0.25],
        comfort: [3, 3, 1.5, 3, 5, 1, 0.5]
      },
      survivalDescriptions: {
        basic: "BASIC SURVIVAL - This is the absolute minimum required to sustain life during an emergency. It includes essentials like water, basic non-perishable food, minimal clothing, and a small first-aid kit. Supplies are strictly limited, so careful rationing is necessary to ensure they last. There's little room for comfort or convenience, focusing entirely on meeting immediate physical needs like hydration, nutrition, and protection from the elements.",
        comfort: "COMFORTABLE SURVIVAL - This level ensures that you have more than the bare essentials, allowing for a more relaxed and less stressful experience. With sufficient supplies, you can maintain a sense of normalcy, including a variety of food options, basic entertainment, hygiene items, and other comforts that make survival more manageable and emotionally uplifting. It allows for less strict rationing and greater flexibility in your daily routine."
      },
      usageSelectors: [
        { id: '#drinking', label: 'Drinking' },
        { id: '#cooking', label: 'Cooking/Hydrate Food' },
        { id: '#flushToilets', label: 'Flush Toilets' },
        { id: '#shower', label: 'Shower' },
        { id: '#washDishes', label: 'Wash Dishes' },
        { id: '#washHands', label: 'Wash Hands/Hygiene' },
        { id: '#waterForAnimals', label: 'Animals/Garden' }
      ],
      totalOutputSelector: '.waterTotal',
      personSelector: '.personCnt',
      monthSelector: '.monthCnt',
      //climateSelector: "input[name='radioButtonClimate']:checked",
      climateSelector: "#state-select",
      survivalTypeSelector: '.mini_survival, .comft_survival',
      survivalDescSelector: '.survival_desc',
      stateClimateMap: {
        'Alabama': 'Hot',
        'Alaska': 'Cold',
        'Arizona': 'Hot',
        'Arkansas': 'Moderate',
        'California': 'Moderate',
        'Colorado': 'Moderate',
        'Connecticut': 'Cold',
        'Delaware': 'Moderate',
        'Florida': 'Hot',
        'Georgia': 'Hot',
        'Hawaii': 'Hot',
        'Idaho': 'Cold',
        'Illinois': 'Cold',
        'Indiana': 'Cold',
        'Iowa': 'Cold',
        'Kansas': 'Moderate',
        'Kentucky': 'Moderate',
        'Louisiana': 'Hot',
        'Maine': 'Cold',
        'Maryland': 'Moderate',
        'Massachusetts': 'Cold',
        'Michigan': 'Cold',
        'Minnesota': 'Cold',
        'Mississippi': 'Hot',
        'Missouri': 'Moderate',
        'Montana': 'Cold',
        'Nebraska': 'Moderate',
        'Nevada': 'Hot',
        'New Hampshire': 'Cold',
        'New Jersey': 'Moderate',
        'New Mexico': 'Hot',
        'New York': 'Cold',
        'North Carolina': 'Moderate',
        'North Dakota': 'Cold',
        'Ohio': 'Cold',
        'Oklahoma': 'Moderate',
        'Oregon': 'Moderate',
        'Pennsylvania': 'Cold',
        'Rhode Island': 'Cold',
        'South Carolina': 'Hot',
        'South Dakota': 'Cold',
        'Tennessee': 'Moderate',
        'Texas': 'Hot',
        'Utah': 'Moderate',
        'Vermont': 'Cold',
        'Virginia': 'Moderate',
        'Washington': 'Moderate',
        'West Virginia': 'Moderate',
        'Wisconsin': 'Cold',
        'Wyoming': 'Cold'
      }
    };

    this.init();
  }

  init() {
    this.bindEvents();
    this.showWaterRequired(); // Initial calculation
    this.storageLocation();
    this.climateDropdown();

  }
  initListeners(data) {
    const products = data.products;
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('add-suggested')) {
        event.preventDefault();
        const variantId = Number(event.target.dataset.variantid);
        const item = { id: variantId, quantity: 1};
        this.handleCartAdd(item, event.target);
      } 
      if (event.target.classList.contains('option-swatch')) {
        const selectedColor = event.target.dataset.option;
        const listingItem = event.target.closest('li');
    
        if (!listingItem) return;
    
        const productImage = listingItem.querySelector('.rec-image');
        if (!productImage) return;
    
        const product = products.find((p) => p.title === listingItem.querySelector('.rec-title').textContent);
        if (!product) return;
    
        const selectedVariant = product.variants.find((variant) => variant.option1 === selectedColor);
    
        if (selectedVariant) {
          productImage.src = selectedVariant.featured_image.src;
          productImage.alt = selectedVariant.title;
          const addButton = listingItem.querySelector('.add-suggested');
          if (addButton) {
            addButton.dataset.variantid = selectedVariant.id;
          }
        }
    
        listingItem.querySelectorAll('.option-swatch').forEach((swatch) => {
          swatch.classList.remove('active');
        });
        event.target.classList.add('active');
      }
    });
  }

  bindEvents() {
    const container = document.querySelector('.water-calculator');
    if (container) {
      container.addEventListener('change', this.handleInputChange.bind(this));
      container.addEventListener('click', this.handleInputChange.bind(this));
    }
  }

  climateDropdown() {
    const dropdown = document.querySelector('#state-select');
    const result = document.querySelector('#climate-result');

    Object.keys(this.config.stateClimateMap)
      .sort()
      .forEach(state => {
        const option = document.createElement('option');
        option.value = state;
        option.textContent = state;
        dropdown.appendChild(option);
      });

    dropdown.addEventListener('change', (event) => {
      const selectedState = event.target.value;
      if (selectedState) {
        const climate = this.config.stateClimateMap[selectedState];
        
        result.textContent = `You live in a ${climate} climate. This is based on the general climate of your state and may vary based on your region.`;
      } else {
        result.textContent = '';
      }
    });
  }


  handleInputChange(event) {
    const target = event.target;
    if (target.matches(this.config.survivalTypeSelector) || 
        target.matches('input[type="checkbox"], input[type="radio"], select')) {
      this.showWaterRequired();
    }
  }

  showWaterRequired() {
    const personCnt = parseInt(this.getValue(this.config.personSelector), 10) || 0;
    const monthCnt = parseInt(this.getValue(this.config.monthSelector), 10) || 0;
    //const climate = this.getCheckedValue(this.config.climateSelector);
    const survivalType = document.querySelector('.mini_survival').checked ? 'basic' : 'comfort';

    const survivalDescElement = document.querySelector(this.config.survivalDescSelector);
    if (survivalDescElement) {
      survivalDescElement.innerHTML = this.config.survivalDescriptions[survivalType];
    }

    const basePrice = this.calculateBasePrice(this.config.survivalTypes[survivalType]);
    const totalGallons = basePrice * personCnt * monthCnt;
    const adjustedGallons = this.applyClimateAdjustment(totalGallons);

    //console.log('adjustedGallons', adjustedGallons);
    
    this.setValue(this.config.totalOutputSelector, Math.round(adjustedGallons));
  }


  calculateBasePrice(survivalArray) {
    return this.config.usageSelectors.reduce((total, usage) => {
      const element = document.querySelector(usage.id);
      if (element && element.checked) {
        total += survivalArray[parseInt(element.value, 10)];
      }
      return total;
    }, 0);
  }

  // fetchCollectionData = (variantId) => {
  //   const product = this.collection.products.filter(product =>
  //     product.variants.some(variant => variant.id === variantId)
  //   );
  //   return product;
  //   //const product = fetch(window.Shopify.routes.root + `products/${handle}.js`)
  //   //.then(response => response.json());
  //   //console.log('product', product);
  // }
  fetchCollectionData = async (handle) => {
    const response = await fetch(window.Shopify.routes.root + `collections/${handle}/products.json`);
    //console.log('collection fetch response', response);
    const collection = await response.json();
    return collection;
  }

  applyClimateAdjustment(totalGallons) {
    const selectedState = document.querySelector('#state-select');
    const climate = this.config.stateClimateMap[selectedState.value];
    //console.log('selectedState', selectedState.value, climate);
    switch (climate) {
      case "Cold":
        return totalGallons * 0.9;
      case "Hot":
        return totalGallons * 1.2;
      default: // Moderate Climate
        return totalGallons;
    }
  }

  storageLocation() {
    const locations = document.querySelectorAll('.storageLocation');
    locations.forEach(location => {
      location.addEventListener('click', async (event) => {
        locations.forEach(l => l.classList.remove('active'));
        event.currentTarget.classList.add('active');
        const data = await this.fetchCollectionData(event.target.dataset.storage);
        console.log('click', data);
        this.displayRecommendations(data);
      });
    });
  }

  displayRecommendations(data) {
    console.log('data product', data);
    const resultHTML = `
    <div class="recommendations-list">
      <header>
        <h3 class="calculator-title">CONSIDERING YOUR STORAGE LOCATION, WE RECOMMEND THE FOLLOWING WATER TANKS:</h3>
      </header>
      <div class="recommendations">
        <ul>
          ${data.products.map(p => {
            const color = p.options.find(z => z.name == 'Color');
            console.log('color', color);
            return (`
            <li>
              <img class="rec-image" src="${p.images[0].src}" alt="${p.title}" />
              <div class="rec-options">
              ${color.values.map((v, i) => {
                return (
                  `<span class="option-swatch swatch-${v.replace(' ', '-').toLowerCase()}" data-option="${v}" data-position="${i}"></span>`
                )
              }).join('')}
              </div>
              <div class="rec-title">${p.title}</div>
              <div class="rec-price">${p.variants[0].price}</div>
              <button class="btn add-suggested" data-variantid="${p.variants[0].id}">Add To Cart</button>
            </li>
          `)}).join('')}
        </ul>
      </div>
    </div>`;

    this.resultsContainer.innerHTML = resultHTML;
    this.initListeners(data);
  }
  toggleFeatured() {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('option-swatch')) {
        const selectedColor = event.target.dataset.option;
        const listingItem = event.target.closest('li');
    
        if (!listingItem) return;
    
        const productImage = listingItem.querySelector('.rec-image');
        if (!productImage) return;
    
        const product = products.find((p) => p.title === listingItem.querySelector('.rec-title').textContent);
        if (!product) return;
    
        const selectedVariant = product.variants.find((variant) => variant.option1 === selectedColor);
    
        if (selectedVariant) {
          productImage.src = selectedVariant.featured_image.src;
          productImage.alt = selectedVariant.title;
        }
    
        listingItem.querySelectorAll('.option-swatch').forEach((swatch) => {
          swatch.classList.remove('active');
        });
        event.target.classList.add('active');
      }
    });
  }
  async handleCartAdd(item, button) {
    let formData = {
      items: [item],
    };

    //console.log(formData);
    const addingSpan = document.createElement('span');
    addingSpan.classList.add('adding');
    addingSpan.textContent = "Adding..."; // Initial message while processing

    button.replaceWith(addingSpan);
    //const originalButtonText = button.textContent;
    //button.textContent = "Adding...";
    //button.disabled = true; // Optionally disable the button
    //const loadingSpinner = this.querySelector('.loading-spinner');
    //if (loadingSpinner) loadingSpinner.classList.remove('hidden');

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify(formData),
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const responseJson = await response.json();
    if (response.ok) {
      //const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      //window.upcartRefreshCart();
      
      addingSpan.textContent = "Added!";
      window.location.href = `${window.Shopify.routes.root}cart`;
    } else {
      console.error('Error adding item to cart:', responseJson);
    }
  }

  // Utilities
  getValue(selector) {
    const element = document.querySelector(selector);
    return element ? element.value : null;
  }
  getCheckedValue(selector) {
    const element = document.querySelector(selector);
    return element ? element.value : null;
  }
  setValue(selector, value) {
    const element = document.querySelector(selector);
    if (element) {
      element.innerHTML = value;
    }
  }
}




document.addEventListener('DOMContentLoaded', () => {
  new WaterCalculator();
});